import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { AccessTokenProvider } from "./contexts/AccessTokenContext";
import i18n from "./i18n";
import { router } from "./router";
import AntdLocaleProvider from "./utils/antdlocaleprovider";

// หลัง deploy ใหม่ hashed chunk เดิมจะหายจาก server — user ที่เปิดแอปค้างไว้แล้วกดไปหน้า lazy จะโหลด chunk ไม่ได้
// จับ event ของ Vite แล้ว reload หนึ่งครั้งเพื่อรับ index ใหม่ (มี guard เวลา กัน reload วนถ้า index เก่าค้าง cache)
const CHUNK_RELOAD_AT_KEY = "chunk-reload-at";
window.addEventListener("vite:preloadError", (event) => {
  const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_AT_KEY) || 0);
  if (Date.now() - lastReloadAt < 10_000) return;
  sessionStorage.setItem(CHUNK_RELOAD_AT_KEY, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AccessTokenProvider>
      <I18nextProvider i18n={i18n} defaultNS={"menus"}>
        <AntdLocaleProvider>
          <RouterProvider router={router} />
        </AntdLocaleProvider>
      </I18nextProvider>
    </AccessTokenProvider>
  </React.StrictMode>
);
